import { useEffect, useState } from "react";
import Api from "../openapi";
import { DietitianBriefResponse } from "../openapi/client";

export default function useDietitians() {
  const [dietitianList, setDietitianList] = useState<DietitianBriefResponse[]>([]);
  useEffect(() => {
    const getDietitians = async () => {
      try {
        const res = await Api.Dietitian.listBriefDietitians();
        setDietitianList(res.data);
      } catch (error) {}
    };
    getDietitians();
  }, []);
  return dietitianList;
}
